import Layout from '@modules/layout/components/layout.vue';
import Permissions from '@security/permissions';

const SchoolListPage = () => import ('@modules/school/components/school-list-page.vue');
const SchoolFormPage = () => import ('@modules/school/components/school-form-page.vue');
const SchoolViewPage = () => import ('@modules/school/components/school-view-page.vue');

export default [{
    name: '',
    path: '',
    component: Layout,
    meta: { auth: true },
    children: [
      {
        props: true,
        name: 'school',
        path: '/school',
        component: SchoolListPage,
        meta: {
          auth: true,
          permission: Permissions.values.schoolView,
        },
      },
      {
        props: true,
        name: 'schoolNew',
        path: '/school/new/',
        component: SchoolFormPage,
        meta: {
                auth: true,
                permission: Permissions.values.schoolCreate,
        },
      },
     
      {
        name: 'schoolEdit',
        path: '/school/:id/edit/',
        component: SchoolFormPage,
        meta: {
                auth: true,
                permission: Permissions.values.schoolEdit,
        },
        props: true,
      },
      {
        name: 'schoolView',
        path: '/school/:id/view/',
        component: SchoolViewPage,
        meta: {
                auth: true,
                permission: Permissions.values.schoolView,
        },
        props: true,
      },
    ],
}];